module.exports = __webpack_public_path__ + "img/productivity-apps.c06a8a1b.png";